// @flow
import { createContext, useContext, type Context } from 'react';


export type InitialContext<Content, Requests> = {
  content: Content,
  loading: boolean,
  request: Requests,
  error?: { [string]: mixed },
  // TODO добавить остальные поля
}

const emptyContext: InitialContext<any, any> = {
  content: {},
  loading: false,
  request: {},
  error: {},
  // TODO добавить остальные поля
};

// Depricated, do not use !
function createApiData() {
  // $FlowFixMe
  return createContext(emptyContext);
}

export function createApiContext<C, R>(initialContent: C, initialRequest: R): Context<InitialContext<C, R>> {
  return createContext<InitialContext<C, R>>({
    ...emptyContext,
    content: initialContent,
    request: initialRequest,
  });
}

export function useApiContext<C, R>(context: Context<InitialContext<C, R>>): InitialContext<C, R> {
  return useContext(context);
}

export default createApiData;
